/** Contact — who placed the order, as the reservation system sent it: name, email, phone,
 *  company, country. Distinct from the order's account (Placed): imports link the account
 *  by this email while none is linked. */
import type { OrderRecordStage } from '@/api/orderRecord';
import type { ViewSection } from '@/features/records/views/types';

import type { OrderDisplayContext } from './displays';
import { OrderStagePanel } from './OrderStagePanel';

export function ContactPanel({
  section,
  display,
}: {
  section: ViewSection<OrderRecordStage>;
  display: OrderDisplayContext;
}) {
  return <OrderStagePanel section={section} display={display} />;
}
